import React from 'react';

import {EMPTY_VALUE} from '@consts/common';
import {STATUS_COLOR_LIST} from '@consts/statuses';
import {StatusWrapper} from '@shared/ui/PageComponents';
import {formatNumberWithFraction} from '@utils/number';

export const formatAmount = (value?: number | string | null) =>
    value == null || value === '' ? EMPTY_VALUE : formatNumberWithFraction(value);

export const statusColor = (liquidated?: boolean | null) =>
    liquidated == null
        ? STATUS_COLOR_LIST.GRAY
        : liquidated
        ? STATUS_COLOR_LIST.GRAY_ALT
        : STATUS_COLOR_LIST.GREEN;

export const riskColor = (value?: string | null) =>
    value === 'RED'
        ? STATUS_COLOR_LIST.RED
        : value === 'YELLOW'
        ? STATUS_COLOR_LIST.YELLOW
        : value === 'GREEN'
        ? STATUS_COLOR_LIST.GREEN
        : STATUS_COLOR_LIST.GRAY;

export const declarationStatusColor = (value?: boolean | number | null) =>
    value === true || value === 1
        ? STATUS_COLOR_LIST.BLUE
        : value === false || value === 0
        ? STATUS_COLOR_LIST.RED
        : STATUS_COLOR_LIST.GRAY;

export const Status = ({children, color}: React.PropsWithChildren<{color: string}>) => (
    <StatusWrapper color={color}>{children}</StatusWrapper>
);
